import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const SubscriptionModule = {
  namespaced: true,

  state: {
    subscription: {},
    subscriptions: []
  },

  getters: {
  },

  actions: {
    async getSubscription ({ commit, state }, subscriptionId) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/subscriptions/' + subscriptionId
      ).then((resp) => {
        commit('storeSubscription', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getSubscriptions ({ commit, state }) {
      commit('setLoading', true, { root: true })
      commit('resetSubscriptions')

      await PaApi().get(
        '/admin/subscriptions'
      ).then((resp) => {
        commit('storeSubscriptions', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    }
  },

  mutations: {
    resetSubscriptions (state) {
      state.subscriptions = []
    },

    storeSubscription (state, payload) {
      state.subscription = processSuccess(payload, baseOpts)
    },

    storeSubscriptions (state, payload) {
      state.subscriptions = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/SubscriptionModule.js